<!--
/**
 * @copyright   OnlyOneProd © 2025
 * @authors     Jonathan COULLET <contact@onlyoneprod.com>
 * @link        https://onlyoneprod.com
 * @notice      All information contained herein is,
 *              and remains the property of OnlyOneProd and its suppliers,
 *              Any dissemination of this information or reproduction
 *              of this material is strictly forbidden unless prior
 *              written permission is obtained from OnlyOneProd.
 */
-->

<template>
    <svg width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
        <g>
            <path
                d="M23.45 26.55H24.55V15.45H23.45V26.55ZM29.45 23.55H30.55V17.45H29.45V23.55ZM17.45 22.55H18.55V17.45H17.45V22.55ZM14.6 41.4V34.2C12.7 32.4667 11.225 30.5417 10.175 28.425C9.12501 26.3083 8.60001 24.1547 8.60001 21.964C8.60001 17.696 10.0972 14.0683 13.0915 11.081C16.0862 8.09367 19.7223 6.6 24 6.6C27.4333 6.6 30.5583 7.65833 33.375 9.775C36.1917 11.8917 38.0167 14.6167 38.85 17.95L40.816 25.746C40.9053 26.182 40.825 26.5667 40.575 26.9C40.325 27.2333 39.9667 27.4 39.5 27.4H35.4V34.7C35.4 35.4167 35.1292 36.0458 34.5875 36.5875C34.0458 37.1292 33.4167 37.4 32.7 37.4H27.4V41.4H26.3V36.3H32.7C33.1667 36.3 33.55 36.15 33.85 35.85C34.15 35.55 34.3 35.1667 34.3 34.7V26.3H39.8L37.8 18.15C37.0333 15.0167 35.35 12.4917 32.75 10.575C30.15 8.65833 27.2333 7.7 24 7.7C20.0267 7.7 16.65 9.0785 13.87 11.8355C11.09 14.5925 9.70001 17.9563 9.70001 21.927C9.70001 23.999 10.122 25.9475 10.966 27.7725C11.8103 29.5972 12.9883 31.208 14.5 32.605L15.7 33.75V41.4H14.6Z"
                fill="currentColor" />
        </g>
    </svg>
</template>

<style lang="sass">
</style>